import apiFetch from '../apiFetch'

export default function (token, userId) {
  return apiFetch({ endPoint: `DownloadSignUser?userId=${userId}`, parseBlobAndAssign: true, method: 'GET', body: null, token: token })
}
